import React from 'react';

import { Loading } from 'uikit/loaders';

import VideosTopic from '../components/videosTopic';

import useVideosTopic from '../hooks/useVideosTopic';

const VideosTopicContainer = () => {
  const {
    data,
    view,
    isLoading,
    handlers,
  } = useVideosTopic();

  const { handleViewChange, followTopic, unfollowTopic } = handlers;

  if (isLoading) return <Loading />;

  return (
    <VideosTopic
      topic={data.data}
      view={view}
      handleViewChange={handleViewChange}
      followTopic={followTopic.mutate}
      unfollowTopic={unfollowTopic.mutate}
    />
  );
};

export default VideosTopicContainer;
